import { objectIs } from 'object-fn-ts/lib';

export default function saveHas(prop: string, x: any) {
  return objectIs(x) && Object.prototype.hasOwnProperty.call(x, prop);
}